<form #form="ngForm" novalidade>
    <div class="card card-primary">
        <div class="card-header">
            <h6 class="card-title mb-0">
                Cotações e Pedidos
            </h6>
           <small class="card-subtitle">Configurações desta unidade de negócio para o lançamento de Cotações e Pedidos</small>
        </div>

        <ul class="list-group list-group-flush list-group-switches">
            <li class="list-group-item">
                <div class="list-group-item-switch-option">
                    <div class="custom-control custom-switch">
                        <input type="checkbox" class="custom-control-input" [(ngModel)]="habilitarComprimentosItensPedidos" (ngModelChange)="habilitarComprimentosItensPedidosChange.emit($event)" name="habilitarComprimentosItensPedidos" id="habilitarComprimentosItensPedidos">
                        <label class="custom-control-label" for="habilitarComprimentosItensPedidos"></label>
                    </div>                 
                </div>
                <div class="list-group-item-switch-text">
                    Habilitar Comprimentos dos Itens     
                    <p class="form-text text-muted">Marque esta opção para habilitar o lançamento das informações de comprimentos nos itens das cotações e pedidos</p>
                </div>                
            </li>
        </ul>
    </div>
</form>
